var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoices" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Post Schedule")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "list" } }, [
                          _vm._v("List Post Schedule")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Post Schedule")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "form-wizard",
                    {
                      attrs: {
                        title: "",
                        subtitle: "",
                        finishButtonText: "Publish",
                        "start-index": _vm.activeIndex,
                        color: "#70C95A"
                      },
                      on: {
                        "on-validate": _vm.onValidate,
                        "update:startIndex": function($event) {
                          _vm.activeIndex = $event
                        },
                        "update:start-index": function($event) {
                          _vm.activeIndex = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "step",
                          fn: function(props) {
                            return _c(
                              "wizard-step",
                              {
                                attrs: {
                                  tab: props.tab,
                                  transition: props.transition,
                                  index: props.index
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center",
                                      "align-items": "center"
                                    },
                                    attrs: { slot: "active-step" },
                                    slot: "active-step"
                                  },
                                  [
                                    props.index == 0
                                      ? _c("lottie", {
                                          attrs: {
                                            options: _vm.animationsForm1,
                                            height: 65,
                                            width: 65
                                          }
                                        })
                                      : props.index == 1
                                      ? _c("lottie", {
                                          attrs: {
                                            options: _vm.animationsForm2,
                                            height: 65,
                                            width: 65
                                          }
                                        })
                                      : props.index == 2
                                      ? _c("lottie", {
                                          attrs: {
                                            options: _vm.animationsForm3,
                                            height: 65,
                                            width: 65
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          }
                        },
                        {
                          key: "footer",
                          fn: function(props) {
                            return [
                              _c(
                                "div",
                                { staticClass: "wizard-footer-left" },
                                [
                                  props.activeTabIndex > 0
                                    ? _c(
                                        "wizard-button",
                                        {
                                          style: props.fillButtonStyle,
                                          nativeOn: {
                                            click: function($event) {
                                              return props.prevTab()
                                            }
                                          }
                                        },
                                        [_vm._v("Previous")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  props.isLastStep
                                    ? _c(
                                        "wizard-button",
                                        {
                                          staticClass: "btn btn-primary",
                                          style: props.fillButtonStyle,
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.onComplete(0)
                                            }
                                          }
                                        },
                                        [_vm._v("Draft")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "wizard-footer-right" },
                                [
                                  !props.isLastStep
                                    ? _c(
                                        "wizard-button",
                                        {
                                          staticClass: "wizard-footer-right",
                                          style: props.fillButtonStyle,
                                          nativeOn: {
                                            click: function($event) {
                                              return props.nextTab()
                                            }
                                          }
                                        },
                                        [_vm._v("Next")]
                                      )
                                    : [
                                        !_vm.isMobile()
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-top": "20px",
                                                  "margin-right": "60%"
                                                }
                                              },
                                              [
                                                _c(
                                                  "center",
                                                  [
                                                    _c(
                                                      "wizard-button",
                                                      {
                                                        staticClass:
                                                          "wizard-footer-right finish-button",
                                                        style:
                                                          props.fillButtonStyle,
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onComplete(
                                                              1
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.isLastStep
                                                              ? "Publish"
                                                              : "Next"
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-top": "20px",
                                                  "margin-right": "60%"
                                                }
                                              },
                                              [
                                                _c(
                                                  "center",
                                                  [
                                                    _c(
                                                      "wizard-button",
                                                      {
                                                        staticClass:
                                                          "wizard-footer-right finish-button",
                                                        style:
                                                          props.fillButtonStyle,
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onComplete(
                                                              1
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.isLastStep
                                                              ? "Publish"
                                                              : "Next"
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                      ]
                                ],
                                2
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm.isLoading
                        ? _c("Skeleton", { attrs: { count: 1 } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            "before-change": _vm.validationForm1,
                            title: "Accounts",
                            icon: "fa fa-list-alt"
                          }
                        },
                        [
                          _c("form1", {
                            attrs: { activeIndex: _vm.activeIndex }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            "before-change": _vm.validationForm2,
                            title: "Content",
                            icon: "fa fa-list-alt"
                          }
                        },
                        [
                          _c("form2", {
                            attrs: { activeIndex: _vm.activeIndex }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        { attrs: { title: "Preview", icon: "fa fa-list-alt" } },
                        [
                          _c("form3", {
                            attrs: { activeIndex: _vm.activeIndex }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f5d3228", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5d3228","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramSchedule/wizard.vue
// module id = null
// module chunks = 